import { render } from "./StudentRegistrationReport.vue?vue&type=template&id=5e225526&scoped=true"
import script from "./StudentRegistrationReport.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationReport.vue?vue&type=script&lang=js"

import "./StudentRegistrationReport.vue?vue&type=style&index=0&id=5e225526&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e225526"]])

export default __exports__